// src/components/ScrollToTop.jsx (simple and effective)
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Instant scroll to top (no animation)
    window.scrollTo(0, 0);
    
    // Or with smooth animation:
    // window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [pathname]);

  return null;
};

export default ScrollToTop;